var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasOpenModals)?_c('div',{staticClass:"modal-backdrop fade in show"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }